<template>
  <div class="nav-info">
    <UiText
      class="nav-info__title"
      font="promo-heading-3"
      :text="$tc('burgerMenu.addInfoTitle')"
      color="typography-title01"
      align-center
    />
    <ul class="nav-info__list">
      <li
        v-for="(page, index) in pagesInfo"
        :key="index"
        class="nav-info__item"
      >
        <NuxtLink
          v-if="page.path && page.path.path"
          class="nav-info__button"
          :to="page.path.path"
        >
          <SvgIcon :name="page.icon" class="nav-info__icon" />
          <UiText
            class="nav-info__text"
            font="body-caption"
            :text="page.text"
          />
          <SvgIcon name="chevrons/chevron-right" class="nav-info__chevron" />
        </NuxtLink>
        <button
          v-else
          type="button"
          class="nav-info__button"
          v-on="page.events"
        >
          <SvgIcon :name="page.icon" class="nav-info__icon" />
          <UiText
            class="nav-info__text"
            font="body-caption"
            :text="page.text"
          />
          <SvgIcon name="chevrons/chevron-right" class="nav-info__chevron" />
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'NavInfo',
  computed: {
    ...mapGetters('user', { isLoggedIn: 'isLoggedIn' }),
    pagesInfo() {
      return [
        {
          path: '',
          events: {
            click: this.open_globalModalSupport,
          },
          icon: 'navigation/headphones',
          text: this.$t('burgerMenu.additionalInfo.help'),
        },
        {
          path: this.$pathObj.faq,
          icon: 'navigation/faq',
          text: this.$t('burgerMenu.additionalInfo.questions'),
        },
        {
          path: this.$pathObj.license,
          icon: 'navigation/shield',
          text: this.$t('burgerMenu.additionalInfo.license'),
        },
      ]
    },
  },
  methods: {
    ...mapActions('globalModal', ['open_globalModalSupport']),
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
